<template>
    <van-popup :value="showNatureMainPop" position="bottom" class="nature-main-popup" v-bind:close-on-click-overlay="false">
        <div class="nature-main-pp-close" @click="clickClose"><i class="iconfont icon-close-solid"></i></div>
        <div class="nature-main-pp-title">
            <p class="title1">知人知面不如八字知天性</p>
            <p class="title2">恭喜获得限时半价解锁天赋性格的机会</p>
        </div>
        <div class="nature-main-pp-content">
            <div class="nature-main-ppc-title">
                <span class="title"><i class="iconfont icon-figure-l"></i>性格解析<i class="iconfont icon-figure-r"></i></span>
            </div>
            <div class="nature-main-ppc-content">
                <p>外露性格分析</p>
                <p>内在心理活动特点分析</p>
            </div>
        </div>
        <div class="nature-main-pp-content">
            <div class="nature-main-ppc-title">
                <span class="title"><i class="iconfont icon-figure-l"></i>天赋能力矩阵<i class="iconfont icon-figure-r"></i></span>
            </div>
            <div class="nature-main-ppc-content">
                <p>先天天赋及弱势提升解析</p>
                <p>适合发挥的工作领域分析</p>
                <p>天赋在今明两年的后天变化表现</p>
            </div>
        </div>
        <div class="nature-main-pp-button">
            <nature-button
                v-bind:buttonType="'1'"
                v-bind:productData="natureGiftData"
                v-bind:discount="natureTimeLimit != 0"
                v-bind:showLimit="natureTimeLimit != 0"
                v-bind:showTwo="natureTimeLimit != 0"
                v-bind:clickFunc="clickPay">
            </nature-button>
            <p v-if="natureTimeLimit != 0" class="nature-main-ppb-note">{{countTimeStr}}后恢复原价{{natureGiftData.rate_price ? parseFloat(natureGiftData.rate_price/100) : ''}}元</p>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config';
import { UTILS } from '../../modules/utils';
import NatureButton from './NatureButton.vue'
export default {
    name: 'NatureMainPopup',
    components: { NatureButton },
    computed: {
        showNatureMainPop() {
            return this.$store.state.report.showNatureMainPop;
        },
        natureGiftData() {
            return this.$store.state.report.natureGiftData;
        },
        natureCharacterData() {
            return this.$store.state.report.natureCharacterData;
        },
        natureTalentData() {
            return this.$store.state.report.natureTalentData;
        },
        natureTimeLimit() {
            return this.$store.state.report.natureTimeLimit;
        }
    },
    data() {
        return {
            showCount: false,
            countTimeStr: '',
            countFunc: undefined,
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            if(me.showNatureMainPop && me.natureTimeLimit > 0) {
                me.initTimeCountDown();
            }
        }, 1000);
    },
    methods: {
        initTimeCountDown() {
            var me = this,
                curSecond = this.natureTimeLimit;
            this.countTimeStr = UTILS.getTimeStrBySecond(curSecond);
            this.countFunc = setTimeout(count, 1000)
            function count() {
                curSecond--;
                clearTimeout(me.countFunc);
                if(curSecond >= 0) {
                    me.$store.state.report.natureTimeLimit = curSecond;
                    me.countTimeStr = UTILS.getTimeStrBySecond(curSecond);
                    me.countFunc = setTimeout(count, 1000);
                }
            }
        },
        clickClose() {
            this.$store.state.report.showNatureMainPop = false;
            clearTimeout(this.countFunc);
            // 更新弹框标记
            this.$store.dispatch('reminder/udpateExtList', {
                params: {"aiCharacter": 1}
            });
        },
        clickPay(params) {
            var me = this,
                curSecond = this.$store.state.report.natureTimeLimit,
                curParams = this.$router.history.current.params,
                detailInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: params.data.payType[2],     //支付方式
                    ext: detailInfo.id,                //支付的评测id
                    discount: curSecond > 0 ? CONFIG.character_discount : 1  //支付折扣
                },
                mixParams: {
                    pid: params.data.pid,
                    product_name: params.data.title,
                    price: params.data.price,
                    from: 'nature',
                },
                sucCb: function() {
                    console.log('支付成功，更新测评报告数据');
                    // 更新测验报告数据
                    if(detailInfo) {
                        me.$store.dispatch('report/getAiCharacter', {
                            detailInfo: detailInfo
                        });
                    }

                    // 更新弹框标记
                    me.$store.dispatch('reminder/udpateExtList', {
                        params: {"aiCharacter": 1}
                    });
                    // 更新ai状态
                    // me.$store.state.detail.personInfo.ai = 1;
                    // me.$store.dispatch('record/updateRecordListAIStatus', {
                    //     id: detailInfo.id
                    // });
                    
                    // 跳转到页面
                    me.$router.replace('/nature/'+curParams.from+'/'+curParams.id);

                    // 清除定时器
                    clearTimeout(me.countFunc);

                    // 支付成功
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: function() {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });

        }
    }
}
</script>